import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormTemplateGeneratorService } from '../../form-template-generator.service';
import { DateConfig, FormFieldConfig } from './../../../form-template-model';

@Component({
  selector: 'csi-form-template-date-field-generator',
  templateUrl: './form-template-date-field-generator.component.html',
  styleUrls: ['./form-template-date-field-generator.component.css']
})
export class FormTemplateDateFieldGeneratorComponent implements OnInit {
  @Input() config: FormFieldConfig & { typeConfig: DateConfig };
  @Input() control: FormControl;
  @Input() formTemplateFieldKey: string;
  @Input() readOnly: boolean;
  @Input() formatForPDF: boolean;
  @Input() supportingFields: { [key: string]: FormFieldConfig };

  public maxDate: Date | null = null;
  public notApplicableFormControl = new FormControl(false);

  constructor(public formTemplateGeneratorService: FormTemplateGeneratorService) {}

  ngOnInit() {
    if (this.config && this.config.typeConfig) {
      if (this.config.typeConfig.maxDateToday === true) {
        this.maxDate = new Date();
      }

      if (this.config.typeConfig.showNotApplicableOption) {
        if (this.control.value === 'N/A' && (this.formatForPDF || this.readOnly)) {
          this.notApplicableFormControl.setValue(true);
        }
        if (!this.readOnly) {
          this.notApplicableFormControl.valueChanges.subscribe(notApplicable => {
            if (notApplicable) {
              this.control.setValue('N/A');
              this.control.setErrors(null); // Remove default mat datepicker validation errors to allow for 'N/A'
            } else {
              this.control.setValue(null);
            }
          });
        } else {
          this.notApplicableFormControl.disable();
        }
      }
    }
  }
}
